import"../../../../../../@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import"../../../../../../lit-html@3.2.1/node_modules/lit-html/lit-html.js";import"../../../../../../lit-element@4.1.1/node_modules/lit-element/lit-element.js";import{css as p}from"../../../../../../@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */const i=p`:host{display:flex;flex-wrap:wrap;gap:8px}
`;export{i as styles};
